import {
  webDocs,
  iosDocs,
  androidDocs,
  restDocs,
  unityDocs,
  gettingStartedMenu,
  edgeauthDocs,
  portalDocs,
  // KB Menus
  howToMenu,
  referenceMenu,
  faqMenu,
  troubleshootMenu,
  reactNativeDocs,
} from '../../menus';

export function getTitle(path: string) {
  return path.includes('/getting-started')
    ? 'Getting Started'
    : path.includes('/faqs')
    ? 'FAQs'
    : path.includes('/how-to')
    ? 'How-To Guides'
    : path.includes('/troubleshooting')
    ? 'Troubleshooting'
    : undefined;
}

/**
 * A helper function that uses the current path to determine which docs menu
 * to render in the side navigation bar
 */
export function getSideMenu(path: string) {
  const menu = path.includes('sdk_ref/web')
    ? webDocs
    : path.includes('sdk_ref/rest-api')
    ? restDocs
    : path.includes('sdk_ref/ios')
    ? iosDocs
    : path.includes('sdk_ref/android')
    ? androidDocs
    : path.includes('/getting-started')
    ? gettingStartedMenu
    : path.includes('sdk_ref/unity')
    ? unityDocs
    : path.includes('sdk_ref/react-native')
    ? reactNativeDocs
    : path.includes('sdk_ref/edgeauth')
    ? edgeauthDocs
    : path.includes('/portal')
    ? portalDocs
    : path.includes('/knowledge-base/how-to')
    ? howToMenu
    : path.includes('/knowledge-base/troubleshooting')
    ? troubleshootMenu
    : path.includes('/knowledge-base/faqs')
    ? faqMenu
    : path.includes('/knowledge-base/reference')
    ? referenceMenu
    : [];

  return menu.map(({ path, submenu, ...rest }) => ({
    path,
    submenu: submenu?.map(({ label, path: submenuPath, submenu: _submenu }) => {
      return { label, path: submenuPath, submenu: _submenu };
    }),
    ...rest,
  }));
}
